import React from 'react'
// graphql
import { useQuery } from '@apollo/client';
import { GET_PAGE_DATA, GET_SEASON_RESULTS } from '../../graphql/queries';
// helmet
import { Helmet } from 'react-helmet';
// components
import PageState from '../../components/Elements/PageState';
import Result from '../../components/Basics/Result';
// utils
import { formatDate } from '../../utils/dateUtils';

export default function Uitslagen() {
  const slug = 'uitslagen';
  // --------- QUERY FOR THE PAGE DATA --------- //
  const { loading, error, data } = useQuery(GET_PAGE_DATA, {
    variables: { slug },
  });
  // Check if data is loaded before accessing seasonSlug
  const seasonSlug = data?.page?.season?.slug;
  // Second query should only be executed if seasonSlug is available
  const { data: dataResults } = useQuery(GET_SEASON_RESULTS, {
    variables: { seasonSlug },
    skip: !seasonSlug, // Skip this query if seasonSlug is not available
  });
  // --------- PAGE DATA --------- //
  const pageData = data?.page;
  const results = dataResults?.results ?? [];
  // --------- RENDER --------- //
  return (
    <PageState loading={loading} error={error}>
      {/* head data */}
      <Helmet>
        <title>{pageData?.title}</title>
        <meta name='description' content={pageData?.pageDescription}/>
      </Helmet>
      {/* last results of a match */}
      <div className='container container--top'>
        <h1 className='container__header'>Uitslagen</h1>
        <div className='container__header'><h3>{pageData?.season?.title}</h3></div>
        <div className='results'>
          {results.map(result => {
            const matchDate = formatDate(result.matchDate);
            return <Result key={result.id} homeTeam={result.homeTeam?.title} awayTeam={result.awayTeam?.title} homeTeamScore={result.homeTeamScore} awayTeamScore={result.awayTeamScore} matchDate={matchDate} competition={result.competition?.title} comment={result.comment} />
          })}
        </div>
      </div>
    </PageState>
  )
}
